var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableempty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 137,
    viewBox: "0 0 140 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.59155,
    cy: 117.771,
    r: 6.59155,
    fill: "#F4F4F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.801,
    cy: 105.32,
    r: 3.80845,
    fill: "#F4F4F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1326,
    cy: 33.8397,
    r: 4.39437,
    fill: "#F4F4F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.68,
    cy: 33.8397,
    r: 4.39437,
    fill: "#F4F4F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.15,
    cy: 63.279,
    r: 6.59155,
    fill: "#F4F4F4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8692,
    cy: 77.0509,
    r: 49.9493,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2275_5238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2754 34.0273L31.4062 84.145C31.4082 84.8909 31.8251 85.5737 32.4877 85.9163L70.0147 105.319V50.1359L31.2754 34.0273Z",
    fill: "url(#paint0_linear_2275_5238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.754 34.0273L108.623 84.145C108.621 84.8909 108.204 85.5737 107.542 85.9163L70.0145 105.319V50.1359L108.754 34.0273Z",
    fill: "url(#paint1_linear_2275_5238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.754 34.03L70.5622 23.1559C70.2042 23.054 69.8249 23.054 69.4669 23.1559L31.2752 34.03L70.0146 50.1714L108.754 34.03Z",
    fill: "url(#paint2_linear_2275_5238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4766 39.9897L58.1498 26.3672L48.9216 29.0038L86.7132 43.2123L94.4766 39.9897Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4766 39.9894L94.6597 48.7357L86.8963 51.9582L86.7132 43.2121L94.4766 39.9894Z",
    fill: "#E1E1E1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2275_5238)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.0151,
    cy: 105.32,
    rx: 14.6479,
    ry: 14.6479,
    fill: "#B1B1B1",
    fillOpacity: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0417 106.863H72.5817L75.9927 110.281L74.9742 111.299L71.5564 107.888V107.348L71.3718 107.157C70.5925 107.827 69.5808 108.23 68.4803 108.23C66.0263 108.23 64.0371 106.241 64.0371 103.787C64.0371 101.333 66.0263 99.3438 68.4803 99.3438C70.9343 99.3438 72.9235 101.333 72.9235 103.787C72.9235 104.887 72.5202 105.899 71.8503 106.678L72.0417 106.863ZM65.4042 103.787C65.4042 105.489 66.7782 106.863 68.4803 106.863C70.1824 106.863 71.5564 105.489 71.5564 103.787C71.5564 102.085 70.1824 100.711 68.4803 100.711C66.7782 100.711 65.4042 102.085 65.4042 103.787Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2275_5238",
    x: 4.27539,
    y: 0.078125,
    width: 131.479,
    height: 136.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.692157 0 0 0 0 0.692157 0 0 0 0 0.692157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2275_5238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2275_5238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2275_5238",
    x: 47.3672,
    y: 82.6719,
    width: 45.2949,
    height: 45.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2275_5238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2275_5238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2275_5238",
    x1: 31.2754,
    y1: 86.1974,
    x2: 75.784,
    y2: 60.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2275_5238",
    x1: 108.754,
    y1: 86.1974,
    x2: 57.4712,
    y2: 54.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2275_5238",
    x1: 86.5595,
    y1: 51.1129,
    x2: 42.5423,
    y2: 18.3349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableempty);
export default __webpack_public_path__ + "static/media/tableempty.9bc3dd8a221d2cdf294e3429cc2c4544.svg";
export { ForwardRef as ReactComponent };